import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "submitButton", "signatureInput"];

  connect() {
    console.log("Staff Signature controller connected");
    this.setupFormSubmission();
  }

  setupFormSubmission() {
    this.formTarget.addEventListener("ajax:success", (event) => {
      const [data, status, xhr] = event.detail;
      
      if (data.success) {
        // Redirect to success page
        window.location.href = data.redirect_url;
      }
    });

    this.formTarget.addEventListener("ajax:error", (event) => {
      const [data, status, xhr] = event.detail;
      
      let errorMessage = "Failed to submit signature. Please try again.";
      if (data && data.error) {
        errorMessage = data.error;
      }
      
      alert(errorMessage);
      this.submitButtonTarget.disabled = false;
    });

    this.formTarget.addEventListener("ajax:before", () => {
      // Validate signature
      if (!this.signatureInputTarget.value || this.signatureInputTarget.value.trim() === "") {
        alert("Please provide your signature before submitting.");
        return false;
      }
    });
  }

  onSignatureChanged(event) {
    // This will be called from signature-pad controller
    // Enable submit button when signature is present
    if (this.hasSubmitButtonTarget) {
      const hasSignature = this.signatureInputTarget.value && 
                          this.signatureInputTarget.value.trim() !== "";
      this.submitButtonTarget.disabled = !hasSignature;
    }
  }
}


